var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"gridFull ma-0"},[_c('v-skeleton-loader',{attrs:{"type":"card-heading"}}),_c('v-skeleton-loader',{attrs:{"type":"table-row-divider"}}),_c('v-skeleton-loader',{attrs:{"type":"table-row"}}),_c('v-skeleton-loader',{attrs:{"type":"table-row"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }